var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import getAlign from './private/utils/getAlign';
import getSide from './private/utils/getSide';
import TooltipContext from './private/utils/TooltipContext';
import useTooltipContext from './private/utils/useTooltipContext';
import mergeClassnames from '../mergeClassnames/mergeClassnames';
import useRegisterChild from '../private/utils/useRegisterChild';
const TooltipRoot = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (React.createElement(RadixTooltip.Provider, { delayDuration: 100 },
        React.createElement(RadixTooltip.Root, Object.assign({}, rest), children)));
};
const Arrow = ({ className }) => {
    const { registerChild } = useTooltipContext('Tooltip.Arrow');
    useEffect(() => {
        registerChild && registerChild('Arrow');
    }, []);
    return (React.createElement(RadixTooltip.Arrow, { asChild: true },
        React.createElement("div", { className: mergeClassnames('relative top-[-7px] rotate-45 w-3 h-3 rounded-sm bg-goku', className) })));
};
const Trigger = (_a) => {
    var { className, children } = _a, rest = __rest(_a, ["className", "children"]);
    return (React.createElement(RadixTooltip.Trigger, Object.assign({ asChild: true, className: className }, rest), children));
};
const Content = (_a) => {
    var _b;
    var { position = 'top-center', className, children, container } = _a, rest = __rest(_a, ["position", "className", "children", "container"]);
    const states = {
        withArrow: false,
    };
    const { state, registerChild } = useRegisterChild();
    const isArrow = (_b = state.childrens) === null || _b === void 0 ? void 0 : _b.find((name) => name === 'Arrow');
    return (React.createElement(TooltipContext.Provider, { value: Object.assign(Object.assign(Object.assign({}, states), state), { registerChild }) },
        React.createElement(RadixTooltip.Portal, { container: container },
            React.createElement(RadixTooltip.Content, Object.assign({ side: getSide(position), align: getAlign(position), sideOffset: isArrow ? 4 : 8, className: mergeClassnames('p-3 rounded-moon-s-xs text-moon-12 text-bulma bg-goku', 'shadow-[0_6px_6px_-6px_rgba(0,0,0,0.16)] drop-shadow-[0_0_1px_rgba(0,0,0,0.4)]', className) }, rest), children))));
};
const Tooltip = Object.assign(TooltipRoot, { Trigger, Content, Arrow });
export default Tooltip;
